module.exports = __webpack_public_path__ + "img/download-blue.fad7f2d0.svg";